/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientListModel } from '../../models/client-list-model';

export interface ClientClientListGet$Json$Params {
}

export function clientClientListGet$Json(http: HttpClient, rootUrl: string, params?: ClientClientListGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<ClientListModel>>> {
  const rb = new RequestBuilder(rootUrl, clientClientListGet$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<Array<ClientListModel>>;
    })
  );
}

clientClientListGet$Json.PATH = '/Client/ClientList';
